import app from '../app.first';
import $ from 'jquery';

app.UsersForm = class extends app.Component {
    constructor($this) {
        super($this);
        $(() => this.onDocumentReady($this));
	}

	onDocumentReady($this) {
            
        $(document).on('click', '#btnFrmSubmit', function(e) {
             /* Maulana: MCQ-143 QA wanted to show the validation message so i just force the form to submit the form even there is some invalid value.
            just to show the message. because currently client side validation only make the input/select and the label become red with no message. */

            $(document).on("forminvalid.zf.abide", function(ev,frm) {
				$( "#btnFrmSubmit" )[0].submit();
            })

        })
        
        // $('.is-invalid-input').change(function() {
        //     console.log('changed')
        //     if($(this).val().length == 0) {
        //         const existingError = $(this).parent().find('.error-message')
        //         if(existingError.length == 0) $(this).parent().append('<div class="error-message">Invalid Value</div>')
        //     } else {
        //         $(this).parent().find('.is-invalid-label').removeClass('is-invalid-label')
        //         $(this).parent().find('.is-invalid-input').removeClass('is-invalid-input')
        //         $(this).parent().find('.error-message').remove()
        //     }
        // })
        
        // $('.field-error').change(function() {
        //     if($(this).val().length == 0) {
        //         const existingError = $(this).parent().find('.error-message')
        //         if(existingError.length == 0) $(this).parent().append('<div class="error-message">Invalid Value</div>')
        //     } else {
        //         $(this).parent().find('.field-error').removeClass('field-error')
        //         $(this).parent().find('.error-message').remove()
        //     }
        // })
    }
}

